// extracted by mini-css-extract-plugin
module.exports = {"Title":"Events-Title-3sq4Z3"};